import { render, staticRenderFns } from "./HeaderRow.vue?vue&type=template&id=08077070"
import script from "./HeaderRow.vue?vue&type=script&lang=js"
export * from "./HeaderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports